'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'trash-check';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e2af';
var svgPathData = ['M60.8 144l326.3 0-22.7 306.4c-1.2 16.7-15.2 29.6-31.9 29.6l-217.1 0c-16.8 0-30.7-12.9-31.9-29.6L60.8 144zm71.7 183.6l54.4 56.3c3.3 3.4 7.9 5.2 12.6 4.8s9.1-2.7 11.8-6.5L316.9 237c5.2-7.1 3.6-17.1-3.5-22.3s-17.1-3.6-22.3 3.5L196.7 348 155.5 305.4c-6.1-6.3-16.3-6.5-22.6-.4s-6.5 16.3-.4 22.6zM149.5 64l11-36.6c1.6-5.2 5.6-9.1 10.6-10.7 1.6-.3 3.2-.6 4.8-.7 .6 0 1.3 0 1.9 0l94.5 0c1.6 .2 3.2 .4 4.8 .7 5 1.6 9 5.5 10.6 10.7l11 36.6-149 0z', 'M83.5 450.4c1.2 16.7 15.2 29.6 31.9 29.6l217.1 0c16.8 0 30.7-12.9 31.9-29.6l22.7-306.4 32.1 0-22.9 308.7c-2.5 33.4-30.3 59.3-63.8 59.3l-217.1 0c-33.5 0-61.4-25.9-63.8-59.3L28.8 144 60.8 144 83.5 450.4zM291.1 218.2c5.2-7.1 15.2-8.7 22.3-3.5s8.7 15.2 3.5 22.3L211.3 382.2c-2.8 3.8-7.1 6.2-11.8 6.5s-9.3-1.4-12.6-4.8l-54.4-56.3c-6.1-6.4-6-16.5 .4-22.6s16.5-5.9 22.6 .4l41.2 42.6 94.4-129.8zM272.2-16c21.2 0 39.9 13.9 46 34.2L331.9 64 432 64c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 96C7.2 96 0 88.8 0 80S7.2 64 16 64l100.1 0 13.8-45.8c6.1-20.3 24.8-34.2 46-34.2l96.4 0zM175.8 16c-7.1 0-13.3 4.6-15.3 11.4l-11 36.6 149 0-11-36.6c-2-6.8-8.3-11.4-15.3-11.4l-96.4 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTrashCheck = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;